import { useWorkspaces } from './useWorkspaces'

export const useWorkspace = (id: number | null) => {
  const workspaces = useWorkspaces()
  return workspaces.find(w => w.id === id)
}
